import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { Button, Col, Row } from 'react-bootstrap';
import Picture from '../common/ShopOfferItem/Picture.jsx';
import createMarkup from '../../../_utils/murkup';


function EducationPurchasesItem(props) {
  const {offer, secret} = {...props};
  return <div className='card mb-3'>
    <Row className='no-gutters'>
      <Col md={2}>
        <div className='card-img text-center'>
          { offer.image && <Picture image={ offer.image } title={offer.title} />}
        </div>
      </Col>
      <Col md={10}>
        <div className="card-body">
          <h6 className="card-title">
            <i className='mr-1 icon icon-graduation-cap' title={ gettext('Обучение') }></i>
            <a href={ offer.url } title={ gettext('Перейти на страницу товара') }>{ offer.title }</a>
            { offer.subtitle ? <><br/><small>{ offer.subtitle }</small></> : '' }
          </h6>
          <div dangerouslySetInnerHTML={ createMarkup(offer.description) }></div>
          <p className="card-text my-2">
            <a href={ offer.author_url }>{ offer.author }</a>, <small className="text-muted">
            { offer.date_format && ' ' + offer.date_format + ', ' }
            <span>
              <span className="statistics__comments mr-2"> { offer.comments_count }</span>
              <span className="statistics__views mr-2"> { offer.views_count }</span>
              <span className="statistics__mark mr-2"> { offer.int_votes_score }</span>
              <span className="statistics__payments mr-2"> { offer.pay_count }</span>
            </span>
          </small>
          </p>
          <p className="small text-muted">{ gettext('Дата покупки') }: { props.date_format }</p>
          <Row className='mb-3'>
            <Col xs={12} sm={6} md={8}>
              { props.file_url && <Button href={ props.file_url } variant='outline-dark' size='sm' className='mr-2 mb-2 mb-md-0'>
                <i className='icon icon-floppy'></i> { gettext('Скачать материалы') }
              </Button> }
              <Button href={ '/ru/my/training-purchase/' + secret + '/' } variant='outline-dark' size='sm' className='mr-2 mb-2 mb-md-0'>
                { gettext('Читать') } <i className='icon icon-right-circled'></i>
              </Button>
            </Col>
            <Col xs={12} sm={6} md={4} className='text-md-right'>
              {/* @todo выводить здесь форму для отзыва */}
              <Button href={ `${offer.url}#add_comment` } variant='outline-dark' size='sm' className='mr-2 mt-2 mt-md-0'>
                <i className='icon icon-comment'></i> { gettext('Оставить отзыв') }
              </Button>
            </Col>
          </Row>
        </div>
      </Col>
    </Row>
  </div>
}

EducationPurchasesItem.propTypes = {
  id: PropTypes.number.isRequired,
  discount: PropTypes.number.isRequired,
}


export default compose(connect(null, {}))(EducationPurchasesItem);

